<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="查询条件">
              <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                <a-select-option value="1">卡密</a-select-option>
                <a-select-option value="2">使用者主账户名称</a-select-option>
                <a-select-option value="3">使用者微信ID</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="查询关键字">
              <a-input v-model="queryParam.keywords" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="是否使用">
              <a-select v-model="queryParam.card_status" placeholder="请选择" allowClear>
                <a-select-option :key="1" :value="0">未使用</a-select-option>
                <a-select-option :key="2" :value="1">已使用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced"></template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="2" @click="handleCopyCards">批量复制</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
    <s-table
      ref="table"
      rowKey="id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1350 }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <div slot="card_number" slot-scope="text, record">
        <a-input-search
          read-only
          :value="record.card_number"
          @search="handleCopy(record.card_number)"
          enterButton="复制"
        />
      </div>
      <div slot="card_status" slot-scope="text, record">
        <a-badge status="error" text="已使用" v-if="record.card_status==1" />
        <a-badge status="success" text="未使用" v-else-if="record.card_status==0" />
      </div>
      <span slot="create_time" slot-scope="text, record">
        <span>{{ record.create_time }}</span>
      </span>
      <span slot="get_robot_info_id" slot-scope="text, record">
        <span v-if="record.card_status == 1">{{ record.get_robot_info?record.get_robot_info.id:'无' }}</span>
        <span v-else>未使用</span>
      </span>
      <span slot="get_robot_info_nickname" slot-scope="text, record">
        <span v-if="record.card_status == 1">{{ record.get_robot_info?record.get_robot_info.nickname:'无' }}</span>
        <span v-else>未使用</span>
      </span>
      <span slot="start_time" slot-scope="text, record">
        <span v-if="record.card_status == 1">{{ record.start_time }}</span>
        <span v-else>未使用</span>
      </span>
      <span slot="remark" slot-scope="text, record">
        <a-tooltip placement="top">
          <template slot="title">
            <span>{{ record.remark }}</span>
          </template>
          <span v-line-clamp="1">{{ record.remark }}</span>
        </a-tooltip>
      </span>
      <div slot="pid" slot-scope="text, record">
        <a v-if="record.pid == 1">月卡</a>
        <a v-else-if="record.pid == 5">年卡</a>
      </div>
      <div slot="user" slot-scope="text, record">
        <a v-if="record.card_status == 1">{{record.user | phone}}</a>
        <span v-else>未使用</span>
      </div>
    </s-table>
  </div>
</template>

<script>
const columns = [
  {
    title: '类型',
    scopedSlots: { customRender: 'pid' }
  },
  {
    title: '卡密',
    scopedSlots: { customRender: 'card_number' }
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'card_status' },
    width: 150
  },
  {
    title: '使用者手机号',
    scopedSlots: { customRender: 'user' }
  },
  {
    title: '机器人ID',
    scopedSlots: { customRender: 'get_robot_info_id' }
  },
  {
    title: '机器人昵称',
    scopedSlots: { customRender: 'get_robot_info_nickname' }
  },
  {
    title: '激活时间',
    scopedSlots: { customRender: 'start_time' }
  },
  {
    title: '创建时间',
    sorter: true,
    dataIndex: 'create_time',
    scopedSlots: { customRender: 'create_time' },
    width: 220
  }
]
import PropertyCardApi from '@/api/property-card'
import { STable } from '@/components'
export default {
  components: {
    STable
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      columns,
      loading: false,
      visible: false,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return PropertyCardApi.getList(Object.assign(parameter, this.queryParam))
      },
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      selectedRowKeys: [],
      selectedRows: [],
    }
  },
  filters:  {
    phone(str){
      str = str.toString()
      const start = str.slice(0,3)
      const end = str.slice(7,11)
      return `${start}****${end}`
    }
  },
  created() {},
  methods: {
    handleCopy(text) {
      this.$copyText(text)
        .then(message => {
          this.$message.success('复制完毕')
        })
        .catch(err => {
          this.$message.error('复制失败')
        })
    },
    refresh() {
      this.$refs.table.refresh(true)
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: true,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleCopyCards() {
      let text = ''
      this.selectedRows.forEach((item)=>{
        text += `${item.card_number}
`})
      this.$copyText(text)
        .then(message => {
          this.$message.success('复制完毕')
        })
        .catch(err => {
          this.$message.error('复制失败')
        })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
